import { getFutureDispatches } from "../../subscription-product/utils/getFutureDispatches.js";
export const getNextDispatch = (dispatches) => {
    if (!dispatches)
        return undefined;
    const futureDispatches = getFutureDispatches(dispatches);
    return futureDispatches[0];
};
